import React, { createContext, useContext, useState, ReactNode } from 'react';
import { type VehicleSelectionValue } from '@/shared/components/VehicleEnrichment';

interface SearchContextType {
  problemDescription: string;
  vehicleData: VehicleSelectionValue;
  setProblemDescription: (problem: string) => void;
  setVehicleData: (vehicle: VehicleSelectionValue) => void;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export const SearchProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [problemDescription, setProblemDescription] = useState('');
  const [vehicleData, setVehicleData] = useState<VehicleSelectionValue>({});

  return (
    <SearchContext.Provider 
      value={{ 
        problemDescription, 
        vehicleData, 
        setProblemDescription, 
        setVehicleData 
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearchContext = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearchContext must be used within SearchProvider');
  }
  return context;
};

// Hook that returns null if context is not available (for components used in both demo and admin)
export const useOptionalSearchContext = () => {
  const context = useContext(SearchContext);
  return context || null;
};